<template>
  <v-card class="mx-auto" flat>
    <v-toolbar color="white" dense light flat  class="d-none d-lg-block" v-if="isMutable">
      <v-toolbar-title>Research Links</v-toolbar-title>

      <v-spacer v-if="researchDocs && researchDocs.length > 1"></v-spacer>
      <div class="d-flex" v-if="researchDocs && researchDocs.length > 1">
        <slot name="sorting"></slot>
      </div>
      <v-spacer></v-spacer>
      <v-btn icon @click="createOptionDialog = true">
        <v-icon color="primary">mdi-plus-circle</v-icon>
      </v-btn>
    </v-toolbar>

    <v-btn fab fixed bottom right v-if="isMutable && researchDocs && researchDocs.length > 0" @click="createOptionDialog = true">
      <v-icon color="primary">mdi-plus-circle</v-icon>
    </v-btn>

    <v-container fluid>
      <v-row dense>
        <v-col cols="12">
          <div class="option-wrapper">
            <v-list flat>
              <v-list-item two-line v-for="researchDoc in researchDocs" :key="researchDoc.id">
                <v-list-item-content>
                  <v-list-item-title>
                    <div class="d-flex align-center" :class="{'justify-start': isMutable, 'justify-center': !isMutable}">
                      <div v-if="isMutable">

                        <v-btn
                        v-if="researchDoc.owner === currentUserID"
                          icon
                          small
                          light
                          class="delete-action"
                          @click.stop="checkDeleteResearchDoc(researchDoc)"
                        >
                          <v-icon small>mdi-trash-can-outline</v-icon>
                        </v-btn>

                      </div>
                      <div :class="{'text-caption': !researchDoc.name}">{{ researchDoc.name ? researchDoc.name : 'unnamed' }}</div>
                    </div>
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    <v-btn v-if="researchDoc.url"
                      text
                      dark
                      x-small
                      target="_blank"
                      :href="researchDoc.url"
                    >
                      <span class="accent--text">{{researchDoc.url}}</span><v-icon class="ml-1" color="accent" x-small>mdi-open-in-new</v-icon>
                    </v-btn>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
            <v-dialog
              v-if="deletingDoc"
              v-model="confirmDeleteDialog"
              persistent
              width="500"
            >

              <v-card>
                <v-card-title class="headline grey lighten-2">
                  Delete Link
                </v-card-title>

                <v-card-text v-if="deletingDoc.name" class="py-4">
                    Are you sure you want to delete <strong>{{ deletingDoc.name }}</strong> from your research list?
                </v-card-text>
                <v-card-text v-else class="py-4">
                    Are you sure you want to delete <strong>{{ deletingDoc.url }}</strong> from your research list?
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="info"
                    text
                    rounded
                    :disabled="deletingFlag"
                    @click="confirmDeleteDialog = false"
                  >
                    Cancel
                  </v-btn>
                  <v-btn
                    color="error"
                    rounded
                    :disabled="deletingFlag"
                    :loading="deletingFlag"
                    @click="deleteResearchDoc(deletingDoc)"
                  >
                    Yes, I am sure
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>

         </div>
       </v-col>
       <v-col v-if="isMutable && (!researchDocs || researchDocs.length === 0)">
         <div class="empty-list-message-container">
           <v-btn icon>
             <v-icon color="primary" @click="createOptionDialog = true">mdi-plus-circle</v-icon>
           </v-btn>
           Add links to keep track of information that helps you make your big decision!
           <div class="text-caption mt-3">These can be links to any information which helps you understand more about what you are deciding on.</div>
         </div>
         <slot name="empty"></slot>
       </v-col>
      </v-row>
    </v-container>

    <!-- New Research doc dialog -->
    <CreateResearchDocDialog
      v-if="isMutable"
      v-model="createOptionDialog"
      @onSaved="handleNewResearchDoc"
    />

  </v-card>
</template>

<script>
  import Constants from '../constants.json'
  // This import loads the firebase namespace along with all its type information.
  import * as firebase from 'firebase/app'
  // Load the auth feature into the firebase namespace.
  import 'firebase/auth'
  import axios from 'axios'

  import CreateResearchDocDialog from '@/components/CreateResearchDocDialog.vue'

  import { mapState } from 'vuex'

  export default {
    name: 'ResearchList',
    components: {
      CreateResearchDocDialog
    },
    computed: {
      ...mapState({
        decisionId: state => state.decision.decisionId
      }),
      currentUserID () {
        return firebase.auth().currentUser.uid
      }
    },
    props: {
      researchDocs: Array,
      isMutable: {
        type: Boolean,
        default: true
      }
    },
    data: () => ({
      createOptionDialog: false,
      confirmDeleteDialog: false,
      deletingDoc: null,
      deletingFlag: false
    }),
    methods: {
      handleNewResearchDoc: function (newResearchDocData) {
        // this.triggerOptionLearning(newOptionData)
        // Add the owner
        newResearchDocData.owner = this.currentUserID
        this.$emit('onNewResearchDoc', newResearchDocData)
      },
      checkDeleteResearchDoc: function (researchDoc) {
        this.deletingDoc = researchDoc
        this.confirmDeleteDialog = true
      },
      deleteResearchDoc: async function (researchDoc) {

        const token = firebase.auth().currentUser && (await firebase.auth().currentUser.getIdToken())
        const deleteDocURL = `${Constants.API_BASE_PATH}/decisions/${this.decisionId}/research/${researchDoc.id}`

        // console.log('Calling delete option')
        this.deletingFlag = true
        const res = await axios.delete(deleteDocURL, {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          }
        })

        if (res && res.status === 200 && res.data && res.data.status === "success") {
          // Emit so the main list can update
          this.$emit('onResearchDocDeleted', researchDoc)
          this.confirmDeleteDialog = false
          this.deletingFlag = false
        } else {
          // console.log(`Unexpected response ${JSON.stringify(res)}`)
          this.deletingFlag = false
          alert('Unexpected response deleting research doc')
        }
      },
      // handleResearchDocDeleted: function (deletedDoc) {
      //   this.$emit('onResearchDocDeleted', deletedDoc)
      // }
    }
  }
</script>

<style scoped lang="scss">
.v-card__title {
  font-size: 1rem;
  position: relative;
}
.compare-fab-button {
  margin-bottom: 80px;
}
.option-wrapper {
  max-width: 100%;
}
.delete-action:hover {
  color: #FFF;
  background-color: rgba(244, 67, 54, 0.7);
}
</style>
